import request from '../../src/state/modules/axios'

export function getCandidates(data){
    return request({
        url: '/api/get-test-candidates',
        method: 'get',
        params: data
    })
}

export function addCandidates(data){
    return request({
        url:'/api/subjects',
        method:'post',
        data
    })
}

export function editCandidates(data){
    return request({
        url: `/api/subjects/${data.id}`,
        method:'put',
        data
    })
}

export function deleteCandidates(data){
    return request({
        url: `/api/candidates/${data.id}`,
        method: 'delete'
    })
}
